module.exports = __webpack_public_path__ + "img/bg.75421b59.jpg";